<div class="cpb5" fxLayout="row wrap">
    <div fxFlex="100" fxFlex.lt-md="100">
        <app-news-filtre
                (searchoptions)="onSearch($event)"
        ></app-news-filtre>
    </div>
    <div fxFlex="100" fxFlex.lt-md="100">
        <mat-card appCard class="table-card">

            <mat-card-content>

                <app-news-table
                        (sort)="onSort($event)"

                        [list]="data"></app-news-table>


                <app-paginator
                        (paginate)="onPaginate($event)"
                        [total]="totalCount"
                ></app-paginator>
            </mat-card-content>
        </mat-card>
    </div>
</div>
